module.exports = {
  gatsbyConfig: {
    property: 'woodwardpa',
    copyrightTagline: 'Woodward PA',
    siteName: 'Camp Woodward PA',
    siteUrl: 'https://www.woodwardpa.com/',
    reCaptchaDBPropertyName: 'Woodward PA',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    color: '#FFD203',
    facebook: '',
    instagram: '',
    twitter: '',
    dynamicTypes: [
      'pressRelease',
      'event',
      'blog',
    ],
  },
  // TODO: Good way of managing API keys per site, maybe use for formbucket and mailchimp?
  contentfulConfig: {
    spaceId: '38vc2unmqsq5',
    accessToken: 'D2b0ZG2uKbPvWdW38GS0y3_hQN9AxH-iJnKijjoI0cA',
  },
};
